module.exports = __webpack_public_path__ + "static/media/exchangeGamesBgTop.11c89455.svg";